import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const pieChartDescription: CalculatorDescription = {
  id: CalculatorId.PieChart,
  title: 'Pie Chart Maker',
  metaTitle: 'Free Online Pie Chart Maker - Create Circle Graphs',
  description: 'Generate pie charts to show proportions and percentages of a whole. Perfect for displaying market share, survey results, or budget allocation.',
  metaDescription: 'Create professional pie charts online. Easy visualization tool for showing parts of a whole. Make clear, engaging circle graphs for your data.',
  howTo: {
    title: 'How to Create a Pie Chart',
    steps: [
      'Enter your data directly into the table or upload a CSV file',
      'Use the "Category column" control to select which column to use for pie segments',
      'Use the "Value column" control to select which numeric column determines segment sizes',
      'Customize your chart with the "Appearance" tab options including chart title, labels, label position, percentages, and chart radius',
      'View your pie chart and download or share it as needed'
    ],
    graphic: {
      description: 'A step-by-step guide showing how to create a pie chart from data input to final visualization'
    }
  },
  examples: [
    {
      title: 'Market Share Analysis',
      description: 'Market share distribution among competitors',
      dataDescription: 'Company names with market share percentages',
      insights: [
        'Market leader holds 35% share',
        'Top 3 companies control 70% of market',
        'Smaller players combined share of 30%',
        'Clear market concentration pattern'
      ]
    },
    {
      title: 'Budget Allocation',
      description: 'Annual budget breakdown by department',
      dataDescription: 'Department names with budget amounts',
      insights: [
        'Marketing department has largest allocation',
        'R&D and Operations have similar budgets',
        'Admin costs kept under 15% of total',
        'Clear spending priorities visualization'
      ]
    },
    {
      title: 'Survey Results',
      description: 'Customer preference survey results',
      dataDescription: 'Response categories with frequencies',
      insights: [
        'Product A is most preferred choice',
        'Even distribution among alternatives',
        'Low percentage of undecided responses',
        'Clear preference pattern visible'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.DonutChart,
    CalculatorId.NightingaleChart,
    CalculatorId.BarGraph
  ]
}; 